import axios from "axios";

import { setAlert } from "../alert";
import { TOKEN_VALID, TOKEN_ERROR } from "../types";

const basePath = process.env.REACT_APP_API_URL + "/api/users";

export const checkToken = token => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "x-auth-token": token
        }
    };

    const body = JSON.stringify({});

    try {
        await axios.post(`${basePath}/check-token`, body, config);

        dispatch({
            type: TOKEN_VALID
        });
    } catch (err) {
        dispatch({
            type: TOKEN_ERROR
        });
    }
};

export const resetPassword = (
    token,
    { password, repassword }
) => async dispatch => {
    if (password !== repassword) {
        dispatch(
            setAlert("Password and Confirm Password do not match", "danger")
        );
    } else {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "x-auth-token": token
            }
        };

        const body = JSON.stringify({ password });

        try {
            const res = await axios.post(
                `${basePath}/reset-password`,
                body,
                config
            );

            const message = res.data.message;

            dispatch(setAlert(message, "success"));
        } catch (err) {
            const error = err.response.data.message;

            if (error) {
                dispatch(setAlert(error, "danger"));
            }
        }
    }
};
